import { FormOption } from 'src/components/form/form-option';
import {
  SingleSelect,
  SingleSelectDropdown,
} from 'src/components/form/select/single-select';

export type SelectOption<Value extends string | null = string> =
  FormOption<Value> & {
    disabled?: boolean;
  };

export const SelectDropdown = SingleSelectDropdown;

export const Select = SingleSelect;
